import { createPatchEndpoint } from '@sonar-software/sonar-http';

export const patchNotifications = createPatchEndpoint(
	'/api/v3/notifications/',
	{
		requestTransform: () => ({
			isRead: true
		})
	}
);
